const React = require('react');
const ArrowBackIcon = require('@material-ui/icons/ArrowBack').default;
const {
  LINK_ADMIN_STATUS,
} = require('../../../../constants/links');
const {
  Link,
} = require('../../../../router');
const withState = require('../../../../utils/withState');
const setTitle = require('../../../../utils/setTitle');
const LayoutB = require('../../../dumb/Layout/B');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const ButtonD = require('../../../dumb/Button/D');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading');


module.exports = withState((setState) => {
  return (state) => {
    const item = state.item || {};
    const name = item.name || '';
    const title = 'Logs: ' + name;
    setTitle(title);
    return (
      <LayoutB>
        <HeaderA>
          <CaptionA>{title}</CaptionA>
          <ButtonD
            component={Link}
            href={LINK_ADMIN_STATUS}
          >
            <ArrowBackIcon/>
            <div className="pl15">Back</div>
          </ButtonD>
        </HeaderA>
        <WrapperWithLoading
          loading={state.loading}
        >
          <textarea
            className="bs bc04 b1 ovx ovyA r5 p10 bg02 cD w hmin350 h100vh-210
              rszN"
            value={item.text}
            readOnly
          />
        </WrapperWithLoading>
      </LayoutB>
    );
  };
}, {
  item: {
    name: 'Ethereum Node',
    /* eslint-disable */
    text: `2020-05-14T04:12:05Z socket recv error Connection reset by peer (104)
2020-05-14T04:14:09Z Potential stale tip detected, will try using extra outbound peer (last tip update: 629 seconds ago)
2020-05-14T04:14:24Z New outbound peer connected: version: 70015, blocks=1840753, peer=5273
2020-05-14T04:16:51Z UpdateTip: new best=81e4ec5165f80d3532b8799b34e46312f73c3e95bd977809fa3689542e4e5904 height=1840754 version=0x20000000 log2_work=73.97953 tx=43237308 date='2020-05-14T04:16:46Z' progress=1.000000 cache=9.0MiB(17621txo)
2020-05-14T04:23:46Z UpdateTip: new best=b71fdc3e2dbf45948a05ff0f94f0f5a4a8e1b1614b427103a709a67cddf0889e height=1840755 version=0x20000000 log2_work=73.979532 tx=43237402 date='2020-05-14T04:23:07Z' progress=1.000000 cache=9.1MiB(17828txo)
2020-05-14T04:26:53Z UpdateTip: new best=6300394915ee2fc709e24a7b36a0fb36a252fbd66bc43f3a3dbdb26acbfbfaf4 height=1840756 version=0x20000000 log2_work=73.979534 tx=43237464 date='2020-05-14T04:26:37Z' progress=1.000000 cache=9.1MiB(17896txo)
2020-05-14T04:27:30Z UpdateTip: new best=ef3bc0d9503fa978db218b78a1e40372b5dc1a2ab318287ce66ac27674f1c608 height=1840757 version=0x20000000 log2_work=73.979537 tx=43237480 date='2020-05-14T04:27:22Z' progress=1.000000 cache=9.1MiB(17900txo)
2020-05-14T04:29:31Z ERROR: AcceptBlock: bad-witness-nonce-size, ContextualCheckBlock : invalid witness reserved value size (code 16)
2020-05-14T04:29:31Z ERROR: ProcessNewBlock: AcceptBlock FAILED (bad-witness-nonce-size, ContextualCheckBlock : invalid witness reserved value size (code 16))
2020-05-14T04:29:31Z ERROR: AcceptBlock: bad-witness-nonce-size, ContextualCheckBlock : invalid witness reserved value size (code 16)
2020-05-14T04:29:31Z ERROR: ProcessNewBlock: AcceptBlock FAILED (bad-witness-nonce-size, ContextualCheckBlock : invalid witness reserved value size (code 16))
2020-05-14T04:29:31Z UpdateTip: new best=2fd17ca78ea1033dd74e2ba249356709aea54e1a65b50a8a2a9e528291182e94 height=1840758 version=0x20000000 log2_work=73.979539 tx=43237499 date='2020-05-14T04:29:15Z' progress=1.000000 cache=9.1MiB(17934txo)
2020-05-14T04:34:17Z UpdateTip: new best=999e28553881ec5f12274556bd2294571e5a122b90b83212313172934536f3b0 height=1840759 version=0x20000000 log2_work=73.979541 tx=43237568 date='2020-05-14T04:34:00Z' progress=1.000000 cache=9.1MiB(18120txo)
2020-05-14T04:35:24Z UpdateTip: new best=2ba497429c430ae4ac795020df4f64bc1a78a37956adceb447f3b32dc329a9b6 height=1840760 version=0x20000000 log2_work=73.979543 tx=43237594 date='2020-05-14T04:35:18Z' progress=1.000000 cache=9.1MiB(18152txo)
2020-05-14T04:35:35Z UpdateTip: new best=bd8ff464cd34472bdc9effa934b0299f6ac2d2d3ebea80c4df819e367d77df63 height=1840761 version=0x20000000 log2_work=73.979545 tx=43237597 date='2020-05-14T04:35:23Z' progress=1.000000 cache=9.1MiB(18223txo)
2020-05-14T04:35:36Z UpdateTip: new best=08febca91a594cfad843db40dbc94f594bcdb769d424bba8de9c23131843bfa8 height=1840762 version=0x20000000 log2_work=73.979547 tx=43237601 date='2020-05-14T04:35:35Z' progress=1.000000 cache=9.1MiB(18225txo)
2020-05-14T04:36:45Z UpdateTip: new best=6bda7ad0e0f622e79e25cd033cff6140cfa88942aafb8e2e95d5ce1f8a6b2fa5 height=1840763 version=0x20000000 log2_work=73.979549 tx=43237613 date='2020-05-14T04:36:13Z' progress=1.000000 cache=9.1MiB(18238txo)
2020-05-14T04:38:18Z UpdateTip: new best=c9717c62a247fd148750ab1a3d256bb1aea3fc477f0b3ef0d7430cb6e375abb1 height=1840764 version=0x20000000 log2_work=73.979551 tx=43237666 date='2020-05-14T04:38:04Z' progress=1.000000 cache=9.1MiB(18289txo)
`
  },
});
